<template>
    <div class="order-info">
        <div class="success-msg">
            <svg width="55" height="55" viewBox="0 0 55 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="27.5" cy="27.5" r="27.5" fill="white"/>
                <circle cx="27.5" cy="27.5" r="27.5" fill="#58B469"/>
                <path d="M14.3439 29.7903L23.5693 39.0158C23.9599 39.4063 24.593 39.4063 24.9836 39.0158L43.0017 20.9977" stroke="#FEFEFE" stroke-width="5" stroke-linecap="round"/>
            </svg>
            <h1>{{ $t('m.returnSuccessTitle') }}</h1>
            <h2 v-html="replaceTranslateContent($t('m.returnSuccessSubtitle'))"/>
            <div class="fee-section">
                <div class="fee-details">
                    <div class="detail-item">
                        <span>{{ $t('m.rentalNumber') }}</span>
                        <span>{{ order_info.rent_no || '-' }}</span>
                    </div>
                    <div class="detail-item">
                        <span>{{ $t('m.rentalTime') }}</span>
                        <span>{{ order_info.rent_at ? time2Date(order_info.rent_at, 'Y-m-d H:i:s') : '-' }}</span>
                    </div>
                    <div class="detail-item">
                        <span>{{ $t('m.returnTime') }}</span>
                        <span>{{ order_info.back_at ? time2Date(order_info.back_at, 'Y-m-d H:i:s') : '-' }}</span>
                    </div>
                    <div class="detail-item">
                        <span>{{ $t('m.rentalDuration') }}</span>
                        <span>{{ getDuration(order_info.rent_at, order_info.back_at) }}</span>
                    </div>
                    <div class="detail-item">
                        <span>{{ $t('m.rentalLocation') }}</span>
                        <span>{{ order_info.rent_outlets || '-' }}</span>
                    </div>
                    <div class="detail-item">
                        <span>{{ $t('m.totalCost') }}</span>
                        <span>{{ order_info.actual_fee != null ? currencyFormat(order_info.actual_fee, order_info.currency) : '-' }}</span>
                    </div>
                </div>
            </div>
            <div v-active-touch class="primary-btn rent-again-btn" @click="$router.push('/payment_select')">
                {{ $t('m.rentAgain') }}
            </div>
        </div>
    </div>
</template>

<script>
import { time2Date, getDuration } from "../../utils/tool";
export default {
    name: "OrderInfo",
    data() {
        return {
            brandName: this.$store.getters['appConfig/brand_name'],
            order_info: this.$store.getters['order_info'],
        }
    },
    methods: {
        time2Date: time2Date,
        getDuration(start, end) {
            if (!start || !end) return '-';
            
            let diff = Math.max(0, end - start); // 秒级时间差
            let days = Math.floor(diff / 86400);
            diff %= 86400;
            let hours = Math.floor(diff / 3600);
            diff %= 3600;
            let minutes = Math.floor(diff / 60);
            let seconds = diff % 60;

            let parts = [];
            if (days > 0) parts.push(`${days} ${this.$tc('time.day', days)}`);
            if (hours > 0) parts.push(`${hours} ${this.$tc('time.hour', hours)}`);
            if (minutes > 0) parts.push(`${minutes} ${this.$tc('time.minute', minutes)}`);
            if (seconds > 0 || parts.length === 0) parts.push(`${seconds} ${this.$tc('time.second', seconds)}`);

            return parts.join(' ');
        }
    },
    mounted() {
        console.log(this.order_info)
    },
};
</script>

<style lang="scss">
    .order-info .success-msg {
        width: 329px;
        position: absolute;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        svg {
            width: 55px;
        }
        h1 {
            margin: 0;
            font-family: 'SF Pro Display';
            font-size: 20px;
            font-weight: 700;
            line-height: 140%;
            margin-top: 15px;
            margin-bottom: 10px;
        }
        h2 {
            margin: 0;
            font-size: 14px;
            font-weight: 400;
            line-height: 20.16px;
            color: #333333;
            text-align: center;
        }
        .fee-section {
            width: 100%;
            margin: 28px 0 20px;
            border-radius: 5px;

            .fee-details {
                background: #F9F9F9;
                padding: 15px;
                display: flex;
                flex-direction: column;
                gap: 9px;

                .detail-item {
                    display: flex;
                    justify-content: space-between;
                    font-size: 12px;
                    color: #666;
                }
            }
        }

        .rent-again-btn {
            width: 100%;
        }
    }
</style>
